module.exports = __webpack_public_path__ + "static/media/lol-provisional.5d6f5142.png";